import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Home";
import Navbar from "./Navbar";
import Footer from "./components/Footer";
import HeroSection from "./pages/HeroSection";
import FirstProgram from "./pages/FirstProgram";
import SecondProgram from "./pages/SecondProgram";
import ThirdProgram from "./pages/ThirdProgram";
import FourthProgram from "./pages/FourthProgram";
import FifthProgram from "./pages/FifthProgram";
import SixthProgram from "./pages/SixthProgram";
import WomenLeadershipPage from "./pages/WomenLeadershipPage";
import YoungLeadersPage from "./pages/YoungLeadersPage";
import HowWeDoItPage from "./pages/HowWeDoItPage";
import TopFAQsPage from "./pages/TopFAQsPage";
import ScrollToTop from "./components/ScrollToTop"; // Import the new component
import AdmissionForm from "./components/AdmissionForm";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import CountryPage from "./CountryPage";
import HelpCategoryPage from "./components/pinkhelp/HelpCategoryPage";
import About from "./components/pinkhelp/About";
import Franchise from "./components/pinkhelp/FranchisePage";
import Contact from "./components/pinkhelp/Contact";
import Advertisers from "./components/pinkhelp/Advertisers";
import Login from "./components/pinkhelp/Login";
// import RoshelleCzar from "./components/pinkhelp/RoshelleCzar";
import WomenOfTheWorld from "./components/pinkhelp/WomenOfTheWorld";
import PinkHelp from "./components/pinkhelp/PinkHelp";
import AboutThisPage from "./components/pinkhelp/AboutThisPage";
import ExclusivePartnership from "./components/pinkhelp/ExclusivePartnership";
import OurServcies from "./pages/OurServcies";
import AdvertisingCountryPage from "./components/pinkhelp/AdvertisingCountryPage";
import CategoryAdverPage from "./components/pinkhelp/CategoryAdverPage";
import EcomerceCountryPage from "./components/pinkhelp/EcomerceCountryPage";
import EcomerceAdverPage from "./components/pinkhelp/EcomerceAdverPage";
import PaymentForm from "./components/pinkhelp/PaymentForm";
import OwnBusiness from "./components/pinkhelp/OwnBusiness";
import NationalCompany from "./components/pinkhelp/NationalCompany";
import FranchisingForm from "./components/pinkhelp/FranchisingForm";

const AppRoutes = () => {
  return (
    <Router>
      <ToastContainer />
      {/* Scroll to Top */}
      <ScrollToTop />

      {/* Navbar */}
      <Navbar />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/help/:category" element={<HelpCategoryPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/our-services" element={<OurServcies />} />
        {/* <Route path="/roshelle-czar" element={<RoshelleCzar />} /> */}
        <Route path="/women-of-the-world" element={<WomenOfTheWorld />} />
        <Route path="/pink-help" element={<PinkHelp />} />
        <Route path="/about-this-page" element={<AboutThisPage />} />
        <Route path="/franchise-page" element={<Franchise />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/advertising-portal" element={<Advertisers />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/exclusive-partnership"
          element={<ExclusivePartnership />}
        />

        <Route path="/help/:category" element={<HelpCategoryPage />} />
        <Route path="/pinkhelp/:countryName" element={<CountryPage />} />

        <Route
          path="/pinkhelp/advertising-portal/"
          element={<AdvertisingCountryPage />}
        />
        <Route
          path="/pinkhelp/advertising-portal/selected"
          element={<CategoryAdverPage />}
        />

        <Route
          path="/pinkhelp/ecommerce-portal/"
          element={<EcomerceCountryPage />}
        />
        <Route
          path="/pinkhelp/ecommerce-portal/selected"
          element={<EcomerceAdverPage />}
        />

        <Route path="/payment-form" element={<PaymentForm />} />

        <Route path="/own-a-busniess" element={<OwnBusiness />} />

        <Route
          path="/pinkhelp/national-company/:countryName"
          element={<NationalCompany />}
        />

        <Route
          path="/pinkhelp/franchising-form/:countryName"
          element={<FranchisingForm />}
        />

        {/* <Route path="/about" element={<About />} /> */}

        <Route path="/herosection" element={<HeroSection />} />

        <Route
          path="/public-company-founders-program"
          element={<FirstProgram />}
        />
        <Route path="/ceo-genesis-program" element={<SecondProgram />} />
        <Route path="/billionaire-blueprint" element={<ThirdProgram />} />
        <Route path="/visionary-accelerator" element={<FourthProgram />} />
        <Route path="/vanguard-rd-lab" element={<FifthProgram />} />
        <Route path="/ethos-leadership-program" element={<SixthProgram />} />

        <Route path="/women-leadership" element={<WomenLeadershipPage />} />

        <Route path="/youngleaders" element={<YoungLeadersPage />} />

        <Route path="/howwedoit" element={<HowWeDoItPage />} />

        <Route path="/faqspage" element={<TopFAQsPage />} />

        <Route path="/admissionform" element={<AdmissionForm />} />
      </Routes>

      {/* Footer */}
      <Footer />
    </Router>
  );
};

export default AppRoutes;
